import {GameService} from "../services/game.service";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {ChangeDetectorRef, Directive, inject} from "@angular/core";
import {DialogLineupComponent} from "../components/dialog-lineup/dialog-lineup.component";
import {DialogResumeGameComponent} from "../components/dialog-resume-game/dialog-resume-game.component";
import {Location} from "@angular/common";
@Directive()
export abstract class AbstractGameComponent{
  public game = inject(GameService);
  public dialog = inject(MatDialog);
  public router = inject(Router);
  public _bottomSheet = inject(MatBottomSheet);
  private location = inject(Location);

  constructor() {
    inject(ChangeDetectorRef);
  }

  openLineupSheet() {
    this._bottomSheet.open(DialogLineupComponent, {
      data: {
        game: this.game.game,
        homeLineup: this.game.lineUp.home,
        awayLineup: this.game.lineUp.away
      },
      panelClass: 'my-bottom-sheet-lineup'
    });
  }

  back() {
    this.location.back();
  }

  openDialogGamePlayList() {
    this.router.navigate(['/game-play-list']);
  }

  openDialogResumeGame() {
    this._bottomSheet.open(DialogResumeGameComponent, {
      panelClass: 'my-bottom-sheet-resume-game'
    });
  }

  addEmptyPlayToGamePlay() {
    this.game.addEmptyPlayToGamePlay();
  }
}
